import Icon, { type IconProps } from '../SvgIcon';

const CheckboxCheckedIcon = ({ fill = 'white', ...rest }: IconProps) => (
  <Icon width={24} height={24} {...rest}>
    <rect xmlns='http://www.w3.org/2000/svg' width='24' height='24' rx='4' />
    <path
      d='M9.55 17.2769C9.42949 17.2769 9.31731 17.2577 9.21348 17.2192C9.10963 17.1808 9.01091 17.1147 8.91733 17.0211L4.74233 12.8462C4.59746 12.7013 4.52759 12.5231 4.5327 12.3116C4.53784 12.1 4.61284 11.9218 4.7577 11.777C4.90257 11.6321 5.07821 11.5596 5.28463 11.5596C5.49103 11.5596 5.66666 11.6321 5.81153 11.777L9.55 15.5154L18.1885 6.87696C18.3333 6.73208 18.5115 6.65964 18.7231 6.65964C18.9346 6.65964 19.1128 6.73208 19.2577 6.87696C19.4025 7.02183 19.475 7.20003 19.475 7.41156C19.475 7.6231 19.4025 7.8013 19.2577 7.94616L10.1827 17.0211C10.0891 17.1147 9.99038 17.1808 9.88653 17.2192C9.78269 17.2577 9.67052 17.2769 9.55 17.2769Z'
      fill={fill}
    />
  </Icon>
);

export default CheckboxCheckedIcon;
